import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Layout from '../Layout';
import Back from '../../../components/common/Back';
import { Editor } from '@tinymce/tinymce-react'; // TinyMCE editor
import {
  fetchPrivacyPolicy,
  updatePrivacyPolicy,
  clearMessages,
} from '../../../redux/slices/admin/privacyPolicyTermsSlice';
import '../../../global.css';

const Policy = () => {
  const dispatch = useDispatch();

  // Selectors from the Redux state
  const {
    privacyPolicy,
    loading,
    error,
    successMessage,
  } = useSelector((state) => state.policy);

  const [content, setContent] = useState(''); // To hold the editor content

  // Fetch the Privacy Policy on component mount
  useEffect(() => {
    dispatch(fetchPrivacyPolicy());
  }, [dispatch]);

  // Populate the editor with fetched content
  useEffect(() => {
    if (privacyPolicy) {
      setContent(privacyPolicy);
    }
  }, [privacyPolicy]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updatePrivacyPolicy(content));
  };

  const handleClearMessages = () => {
    dispatch(clearMessages());
  };

  return (
    <Layout>
      <main className="main">
        <header>
          <div className="main-head flex justify-between align-center pb-0">
            <h1 className="greet-user-text">Update Privacy Policy</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </div>
        </header>
        <div className="main-content flex justify-between flex-col-rev-mob">
          <div style={{ width: '100%' }}>
            <div className="meals-container meals-added">
              <div className="card">
                {/* Bootstrap Alerts */}
                {successMessage && (
                  <div
                    className="alert alert-success alert-dismissible fade show"
                    role="alert"
                  >
                    {successMessage}
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleClearMessages}
                    ></button>
                  </div>
                )}
                {error && (
                  <div
                    className="alert alert-danger alert-dismissible fade show"
                    role="alert"
                  >
                    {error}
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleClearMessages}
                    ></button>
                  </div>
                )}
                <form
                  onSubmit={handleSubmit}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                  }}
                >
                  <Editor
                    apiKey="3ekhofkbsu98q13bzu60y7zbqcr9yd5fhnmhz706zfyv2ges" // Replace with your TinyMCE API key
                    value={content}
                    onEditorChange={(newContent) => setContent(newContent)}
                    init={{
                      height: 400,
                      menubar: true,
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
                      content_style:
                        'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                    }}
                  />
                  <div className="form-buttons">
                    <button type="submit" className="btn btn-create w-100">
                      Update Privacy Policy
                    </button>
                  </div>
                </form>
              </div>
              {loading && <p>Loading...</p>}
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default Policy;